import {FirebaseApp} from "@/plugins/Firebase";
import {collection, doc, getFirestore, addDoc, onSnapshot} from "firebase/firestore";
import {Store} from "@/plugins/Store";
import {Functions} from "@/plugins/Functions";

const db = getFirestore(FirebaseApp);

/**
 * A document nobody handles (the function is down, or being replaced during a
 * deploy) gets neither url nor error; the user sees the error and can retry.
 */
const CHECKOUT_WAIT_MS = 60_000;

const Stripe = {
    // CheckoutSessionOnCreateObserver writes url, or error when Stripe refuses
    // the session, to the new checkout_sessions document.
    createStripeCheckoutSession: function (priceId: string, userUid: string, oneTime = false): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const data = {
                price: priceId,
                success_url: window.location.origin,
                cancel_url: window.location.origin,
                // @ts-ignore
                client_reference_id: window.Rewardful && window.Rewardful.referral || ('checkout_'+(new Date).getTime())
            };
            if (oneTime) {
                (data as any).mode = "payment";
            }
            addDoc(collection(doc(collection(db, 'users'), userUid), 'checkout_sessions'), data).then(docRef => {
                const timeout = setTimeout(() => {
                    snapshotListenerStop();
                    reject(new Error('Checkout session was not created in time'));
                }, CHECKOUT_WAIT_MS);
                const snapshotListenerStop = onSnapshot(docRef, snapshot => {
                    const data = snapshot.data();
                    if (data && data.url) {
                        clearTimeout(timeout);
                        snapshotListenerStop();
                        resolve(data.url);
                    } else if (data && data.error) {
                        clearTimeout(timeout);
                        snapshotListenerStop();
                        reject(new Error(data.error.message));
                    }
                }, error => {
                    clearTimeout(timeout);
                    reject(error);
                });
            }).catch(reject);
        });
    },

    createCustomerPortalSession: function (): void {
        Functions.CreateStripePortalLink({returnUrl: window.location.href})
            .then(({url}) => {
                window.location.assign(url);
            })
            .catch(() => {
                Store.dispatch("handleApiError");
            });
    }
};

export {Stripe};
